import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Table = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding: 10px 15px;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.palette.secondary.border};
  background-color: ${({ theme }) => theme.palette.primary.background};
`;

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  &:not(:last-child) {
    border-right: 1px solid ${({ theme }) => theme.palette.secondary.border};
  }
`;

export const Label = styled(Typography.Caption)`
  color: ${({ theme }) => theme.palette.primary.labels};
  margin-bottom: 5px;
  display: flex;
  gap: 5px;
`;

export const DeactivationInfo = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.primary.labels};
  text-align: center;
  margin-top: 25px;
`;

export const Actions = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 15px;
`;

export const Contacts = styled.div`
  display: grid;
  justify-items: center;
  gap: 15px;
  padding: 30px 0;
`;

export const ContactsText = styled(Typography.Body)`
  text-align: center;
`;
